import fiatRampReduxFactory from '@exodus/fiat-ramp/redux';
import type { ReduxModuleDefinition } from '@exodus/redux-dependency-injection';

import type { NamedReduxModuleDefinition } from '@/types';
import type { FiatRampInitialState, WidgetAvailabilityState } from './types.js';
import { FIAT_PROVIDER_ATOM_EVENT } from '../plugins/provider.js';
import { FIAT_WIDGET_AVAILABILITY_EVENT } from '../plugins/widget.js';

const fiatRampReduxDefinition = (params?: unknown) => {
  const fiatRampRedux = fiatRampReduxFactory(
    params,
  ) as NamedReduxModuleDefinition<'fiatRamp'>;

  return {
    ...fiatRampRedux,
    initialState: {
      ...fiatRampRedux.initialState,
      provider: null,
      widgetAvailability: null,
    } as FiatRampInitialState,
    eventReducers: {
      ...fiatRampRedux.eventReducers,
      [FIAT_PROVIDER_ATOM_EVENT]: (state, payload: string) => ({
        ...state,
        provider: payload,
      }),
      [FIAT_WIDGET_AVAILABILITY_EVENT]: (
        state,
        payload: WidgetAvailabilityState,
      ) => ({
        ...state,
        widgetAvailability: payload,
      }),
    },
  } as const satisfies ReduxModuleDefinition;
};

export default fiatRampReduxDefinition;
